module.exports = __webpack_public_path__ + "static/img/1_0010.a0d8de6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0010.jpg
// module id = ipEl
// module chunks = 0